export function HorizontalDivider() {
  return <div className="o-scheduler-horizontal-divider" />
}
